export default __webpack_public_path__ + "static/5_33-c922a4c8c96a6e20918523ecee3e2e53.png";